import styled from 'styled-components';
import { CenterRowDiv, List, RowDiv, theme } from 'styles';

export const HeaderDiv = styled(RowDiv)`
  padding: 16px;
  border-bottom: 1px solid ${theme.colors.gray100};
`;

export const StatDiv = styled(CenterRowDiv)`
  width: 64px;
  height: 24px;
  border-radius: 12px;
  justify-content: center;

  ${({ $type }) =>
    $type === 0 ? `border:1px solid ${theme.colors.gray200}` : `background-color:${theme.colors.primary50}`};

  p {
    color: ${({ $type }) => ($type === 0 ? theme.colors.gray400 : theme.colors.primary)};
  }
`;
